"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const utils_1 = require("./utils");
const index_1 = require("../index");
const TimeZoneRow = ({ device, onClick, value }) => (React.createElement("div", { style: {
        alignItems: 'center',
        display: 'flex',
        minHeight: device === 'Mobile' ? 96 : 80,
        justifyContent: 'space-between',
        borderBottom: `1px solid ${index_1.titanium}`,
    }, onClick: onClick },
    React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            padding: device === 'Mobile' ? '24px 0' : '16px 0',
        } },
        React.createElement(index_1.Text, { text: "Time zone", size: "small", label: true, textStyle: { color: index_1.steel } }),
        React.createElement(index_1.Text, { text: utils_1.getDisplayTimeZone(value), size: device === 'Mobile' ? 'large' : 'medium' })),
    React.createElement(index_1.ChevronRightIcon, { fill: index_1.silver })));
exports.default = TimeZoneRow;
